import React, { useEffect, useState } from 'react';

import robotImg from '../../assets/images/robot.png';
import {
  LoadingPageContainer,
  LoadingPageRobot,
  LoadingPageSpace,
  LoadingPageText,
} from './loading-page.styles';

const LoadingPage = () => {
  const [text, setText] = useState('');

  useEffect(() => {
    const loadingText = 'Loading';
    const timers: number[] = [];
    const intervals: number[] = [];

    loadingText.split('').forEach((_, i) => {
      timers.push(
        window.setTimeout(
          () => setText(loadingText.slice(0, i + 1)),
          100 * i
        )
      );
    });

    timers.push(window.setTimeout(() => {
      intervals.push(window.setInterval(() => {
        let mockText = loadingText;
        setText(mockText.replace('o', '6'));
      }, 600));
      intervals.push(window.setInterval(() => {
        let mockText = loadingText;
        setText(mockText.replace('d', '3'));
      }, 900));
      intervals.push(window.setInterval(() => {
        let mockText = loadingText;
        setText(mockText.replace('g', '8'));
      }, 700));
    }, 100 * loadingText.length));

    return () => {
      timers.forEach((timer) => window.clearTimeout(timer));
      intervals.forEach((interval) => window.clearInterval(interval));
    };
  }, []);

  return (
    <LoadingPageContainer>
      <LoadingPageRobot src={robotImg} />
      <LoadingPageText>
        {text}
        <LoadingPageSpace>_</LoadingPageSpace>
      </LoadingPageText>
    </LoadingPageContainer>
  );
};

export default LoadingPage;
